var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-field-container",class:[{ active: _vm.isActive }, { 'no-value': !_vm.hasValue }],attrs:{"icon":true},on:{"click":function($event){return _vm.$emit('upload')}}})}
var staticRenderFns = []

export { render, staticRenderFns }